import { ShoppbudAPI } from "@inhouse-market/sdk";
import env from "../env";
import pkg from "../../app.json";

export const apiSDK = new ShoppbudAPI({
  url: env.API,
  platformAndVersion: "web",
  appVersion:  pkg?.expo?.version || "unknown"
});
